/* Findvoya homepage chapters: scroll-driven product turn + quick-buy add to cart. */
(() => {
  if (window.fvChapters) return;
  window.fvChapters = true;

  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  /* chapters */
  const chapters = [];
  function setup(root) {
    if (root.dataset.fvcReady) return;
    root.dataset.fvcReady = '1';
    const callouts = [...root.querySelectorAll('.fvc__callout')];
    const frames = [...root.querySelectorAll('.fvc__frame')];
    chapters.push({ root, track: root.querySelector('.fvc__track'), callouts, frames, step: -1 });
  }

  function update() {
    const vh = innerHeight;
    chapters.forEach((c) => {
      if (!c.root.classList.contains('is-live')) return;
      const r = c.track.getBoundingClientRect();
      if (r.bottom < -vh || r.top > vh * 2) return;
      const span = Math.max(1, r.height - vh);
      const p = Math.min(1, Math.max(0, -r.top / span));
      c.root.style.setProperty('--p', p.toFixed(4));
      const n = c.callouts.length;
      if (!n) return;
      const step = Math.min(n - 1, Math.floor(p * n));
      if (step === c.step) return;
      c.step = step;
      c.callouts.forEach((el, i) => {
        el.classList.toggle('is-on', i === step);
        el.classList.toggle('is-past', i < step);
      });
      const f = parseInt(c.callouts[step].dataset.frame, 10);
      if (c.frames.length > 1 && f >= 0 && f < c.frames.length) {
        c.frames.forEach((el, i) => el.classList.toggle('is-on', i === f));
      }
    });
  }

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { ticking = false; update(); });
  };

  function applyMotion() {
    chapters.forEach((c) => {
      c.root.classList.toggle('is-live', !reduce.matches);
      c.step = -1;
      if (reduce.matches) {
        c.root.style.removeProperty('--p');
        c.callouts.forEach((el) => el.classList.remove('is-on', 'is-past'));
      }
    });
    update();
  }

  function init() {
    document.querySelectorAll('[data-fvc]').forEach(setup);
    applyMotion();
  }

  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll);
  reduce.addEventListener?.('change', applyMotion);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* quick buy */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('.fvq__select');
    if (!sel) return;
    const price = sel.closest('.fvq__card').querySelector('.fvq__price');
    const opt = sel.selectedOptions[0];
    if (price && opt && opt.dataset.price) price.textContent = opt.dataset.price;
    const img = sel.closest('.fvq__card').querySelector('.fvq__media img');
    if (img && opt && opt.dataset.img) { img.removeAttribute('srcset'); img.src = opt.dataset.img; }
  });

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-fv-quickadd]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('.fvq__add');
    const msg = form.querySelector('.fvq__msg');
    const label = btn.textContent;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = new FormData(form);
    if (cart && cart.getSectionsToRender) {
      body.append('sections', cart.getSectionsToRender().map((s) => s.id));
      body.append('sections_url', location.pathname);
      cart.setActiveElement && cart.setActiveElement(btn);
    }
    btn.disabled = true;
    btn.textContent = '…';
    msg.textContent = '';
    try {
      const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body });
      const json = await res.json();
      if (!res.ok || json.status) throw new Error(json.description || json.message || 'Could not add');
      if (cart && cart.renderContents && json.sections) {
        cart.renderContents(json);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      } else {
        msg.innerHTML = '';
        const a = document.createElement('a');
        a.href = root + 'cart';
        a.textContent = 'Added – view cart';
        msg.append(a);
      }
    } catch (err) {
      msg.textContent = err.message;
    } finally {
      btn.disabled = false;
      btn.textContent = label;
    }
  });
})();
